import axios from "axios";
import { errorSnackMsg } from "../../../../Custom Hooks/SnackkBarUtilities";
import { HEADERS } from "../../../../../API/UrlAndPaths";

/**
 * Authenticate employee for POS operations (Order Edit, Order Cancel, Discount)
 * @param {Object} payload - { employeeId, password }
 * @param {Function} setLoading - Loading state setter
 * @returns {Promise<Object>} - Authentication result
 */
export const authenticateEmployeeAPI = async (payload, setLoading) => {
    try {
        if (setLoading) setLoading(true);
        
        // Use relative URL and standard HEADERS so baseURL and auth token are applied
        const response = await axios.post(
            "employee/authenticateForPOS",
            payload,
            HEADERS
        );

        if (setLoading) setLoading(false);

        console.log('🔐 Auth API Response:', response?.data);
        console.log('🔐 Auth API Response Data:', response?.data?.data);

        if (response?.data?.data?.success) {
            return {
                success: true,
                employee: response.data.data.employee,
                message: response.data.data.message
            };
        } else {
            console.warn('⚠️ Auth failed - Response:', response?.data);
            errorSnackMsg(response?.data?.data?.message || "Authentication failed");
            return {
                success: false,
                message: response?.data?.data?.message || "Authentication failed"
            };
        }
    } catch (error) {
        if (setLoading) setLoading(false);
        console.error("Employee authentication error:", error);
        errorSnackMsg(error?.response?.data?.data?.message || "Authentication failed");
        return {
            success: false,
            message: error?.response?.data?.data?.message || "Authentication failed"
        };
    }
};
